import styles from "./LoadingScreen.module.css";

const LoadingScreen = ({ message = "Loading Chatify…" }) => (
  <div className={styles.overlay}>
    <div className={styles.card}>
      {/* Animated chat bubbles */}
      <div className={styles.bubbles}>
        <div className={`${styles.bubble} ${styles.b1}`}>
          <span />
          <span />
          <span />
        </div>
        <div className={`${styles.bubble} ${styles.b2}`}>
          <span />
          <span />
          <span />
        </div>
        <div className={`${styles.bubble} ${styles.b3}`}>
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className={styles.logo}>💬</div>
      <h2 className={styles.title}>Chatify</h2>
      <p className={styles.message}>{message}</p>
      <div className={styles.bar}>
        <div className={styles.barFill} />
      </div>
    </div>
  </div>
);

export default LoadingScreen;
